import React, {useState} from 'react';
import {useFragment} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import {Card} from "react-bootstrap";
import {useUser} from "../../../hooks/useUser";
import AdvanceTableWrapper from "../../../components/common/advance-table/AdvanceTableWrapper";
import CardTableHeader from "../../../components/common/headers/CardTableHeader";
import AdvanceTable from "../../../components/common/advance-table/AdvanceTable";
import AdvanceTableFooter from "../../../components/common/advance-table/AdvanceTableFooter";
import {BooleanCell, LinkCell} from "../../../components/common/advance-table/CustomCells";
import NewLocationFacilityModal from "./NewLocationFacilityModal";

const cols = [
    {accessor: "facility.applicableVersion.displayName",
    Header: "Name",
    headerProps: {className: 'pe-1'},
        Cell: rowData => {
        const { facility, id} = rowData.row.original;
        return <LinkCell name={facility.applicableVersion.displayName} to={"/facility-locations/" + id} hasAvatar />
        }
    },
    {accessor: "legalContractLineOfService.lineOfService.name", Header: "Line of Service"},
    {accessor: 'applicableVersion.showInDirectory', Header: "Show In Directory", Cell:BooleanCell},
]
const LocationFacilities = ({locationId, facilities, allBillingGroups, availableLinesOfService, allFacilities}) => {
    const data = useFragment(graphql`
        fragment LocationFacilities_Facilities on FacilityLocation @relay(plural: true) {
            id
            facility {
                applicableVersion {
                    displayName
                }
            }
            legalContractLineOfService {
                id
                lineOfService {
                    id
                    name
                }
            }
            applicableVersion {
                showInDirectory
            }
        }
    `, facilities)
    const {hasPermission} = useUser();
    const [showNewModal, setShowNewModal] = useState(false);
    return (
        <>
            <AdvanceTableWrapper columns={cols}
                                 sortable
                                 data={data}
                                 pagination
                                 perPage={10}
            >
                <Card className={"mb-3"}>
                    <Card.Header>
                        <CardTableHeader onNewClick={() => {setShowNewModal(true)}}
                                         title={"Facilities"}
                                         table
                                         showNew={hasPermission("FacilityLocation.Create")} />
                    </Card.Header>
                    <Card.Body className={"p-0"}>
                        <AdvanceTable table
                                      headerClassName={"bg-200 text-900 text-nowrap align-middle"}
                                      rowClassName={"align-middle white-space-nowrap"}
                                      tableProps={{size: "sm", striped: true, className: "fs--1 mb-0 overflow-hidden"}}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTableFooter table
                                            rowCount={data.length}
                                            rowInfo
                                            navButtons
                                            rowsPerPageSelection
                        />
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
            <NewLocationFacilityModal availableLinesOfService={availableLinesOfService}
                                      allFacilities={allFacilities}
                                      allBillingGroups={allBillingGroups}
                                      locationId={locationId}
                                      showModal={showNewModal}
                                      onClose={() => {setShowNewModal(false)}}
            />
        </>
    )
}
export default LocationFacilities